export default __webpack_public_path__ + "static/media/image.impact-i-t-solutions-pvt-ltd.b01d972b.png";